import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { ModalSolicitacaoCancelamento, CancelarSolicitacaoParam, TipoOrigemEnum } from '@/types/_'
import { Cancelamento, SolicitacaoCirurgiaImp } from '@/types/core'

@Module({ namespaced: true, name: 'SolicitacaoCancelamentoStore' })
export default class SolicitacaoCancelamentoStore extends VuexModule {
  modal: ModalSolicitacaoCancelamento = {
    cancelamentoAgendamento: false,
    cancelamentoTriagem: false,
    cancelamentoAutorizacao: false,
    cancelamentoMedico: false,
    cancelamentoGeral: false,
  }

  cancelarSolicitacaoParamDefault: CancelarSolicitacaoParam = {
    canceladoMotivo: {
      display: '',
      key: '',
    },
    situacao: {
      display: '',
      key: '',
    },
    solicitacaoId: '',
    tipoOrigem: TipoOrigemEnum.Undefined,
    modal: '',
  }

  cancelarSolicitacaoParam: CancelarSolicitacaoParam = { ...this.cancelarSolicitacaoParamDefault }
  motivo: string = ''
  motivoMessage: string = ''
  observacaoDoCancelamento: string = ''
  cancelamento: Cancelamento.ICancelamento = new Cancelamento.Cancelamento()
  habilitarObservacaoDoCancelamento: boolean = false
  motivosCancelamento: any[] = []
  solicitacaoCirurgiaImp: SolicitacaoCirurgiaImp.ISolicitacaoCirurgiaImp = new SolicitacaoCirurgiaImp.SolicitacaoCirurgiaImp()

  @Action
  async cancelarSolicitacao() {
    const params: any = {
      solicitacaoId: this.cancelarSolicitacaoParam.solicitacaoId,
      tipoOrigem: this.cancelarSolicitacaoParam.tipoOrigem,
      motivoCancelamento: this.motivo,
      observacaoDoCancelamento: this.observacaoDoCancelamento,
    }

    const response = this.cancelamento.cancelarSolicitacao(params)
    return response
  }


  @Action
  async getMotivosCancelamentoAll(params: any) {
    const response = await this.cancelamento.getMotivosCancelamentoAll(params)
    if (response.success) {
      const { commit } = this.context
      commit('setMotivosCancelamento', response.data)
      const { hospitalId } = params
      const templateResponse = await this.solicitacaoCirurgiaImp.getTemplateHospital(hospitalId)
      if (templateResponse.success) this.context.commit('setHabilitarObservacaoDoCancelamento', JSON.parse(templateResponse.data.template))
    }
    return response
  }

  @Action
  async solicitaCancelamentoSolicitacao(motivo: string) {
    const params: any = {
      solicitacaoId: this.cancelarSolicitacaoParam.solicitacaoId,
      motivo,
    }

    const response = this.cancelamento.solicitaCancelamentoSolicitacao(params)
    return response
  }

  @Action
  async deactivateSurgerySolicitation({ notes, deactivationReason, surgerySolicitationId }) {
    const response = this.cancelamento.deactivateDoctorSurgerySolicitation(surgerySolicitationId, {
      observacao: notes,
      motivoCancelamentoDaSolicitacaoId: deactivationReason,
    })
    return response
  }

  @Action
  async cancelarSolicitacaoMedico(motivo: string) {
    const params: any = {
      solicitacaoId: this.cancelarSolicitacaoParam.solicitacaoId,
      motivo,
      observacaoDoCancelamento: this.observacaoDoCancelamento,
    }
    const response = this.cancelamento.cancelarSolicitacaoMedico(params)
    return response
  }

  @Mutation
  setMotivosCancelamento(data: any) {
    this.motivosCancelamento = data
  }

  @Mutation
  setHabilitarObservacaoDoCancelamento(template: any) {
    this.habilitarObservacaoDoCancelamento = template.formulario.observacaoDoCancelamento && template.formulario.observacaoDoCancelamento.habilitado
  }

  @Mutation
  setSolicitacaoId(solicitacaoId: string) {
    this.cancelarSolicitacaoParam.solicitacaoId = solicitacaoId
  }

  @Mutation
  setCancelarSolicitacaoParam(param: CancelarSolicitacaoParam) {
    this.cancelarSolicitacaoParam = param
    this.motivo = param.canceladoMotivo ? param.canceladoMotivo.key : ''
  }

  @Mutation
  setMotivo(motivo: string) {
    this.motivo = motivo
  }

  @Mutation
  setMotivoMessage(message: string) {
    this.motivoMessage = message
  }

  @Mutation
  setObservacaoCancelamento(message: string) {
    this.observacaoDoCancelamento = message
  }

  @Mutation
  setShowModalCancelamentoAgendamento(value: boolean) {
    this.modal.cancelamentoAgendamento = value
  }

  @Mutation
  setShowModalCancelamentoTriagem(value: boolean) {
    this.modal.cancelamentoTriagem = value
  }

  @Mutation
  setShowModalCancelamentoGeral(value: boolean) {
    this.modal.cancelamentoGeral = value
  }

  @Mutation
  setShowModalCancelamentoAutorizacao(value: boolean) {
    this.modal.cancelamentoAutorizacao = value
  }

  @Mutation
  setShowModalCancelamentoMedico(value: boolean) {
    this.modal.cancelamentoMedico = value
  }

  @Mutation
  clear() {
    this.cancelarSolicitacaoParam = { ...this.cancelarSolicitacaoParamDefault }
    this.motivo = ''
    this.observacaoDoCancelamento = ''
  }

  @Mutation
  clearCancelarSolicitacaoParam() {
    this.cancelarSolicitacaoParam = { ...this.cancelarSolicitacaoParamDefault }
  }
}
